/** Asset management routes. */

import Layout from '@/layout/index'

const attachmentRouter = {
  path: '/assets',
  component: Layout,
  name: 'Assets',
  meta: {
    title: 'router.asset'
  },
  children: [
    {
      path: '',
      component: () => import('@/views/attachment/index.vue'),
      name: 'AssetManagement',
      meta: {
        title: 'router.asset'
      }
    },
    {
      path: ':folder_code',
      component: () => import('@/views/attachment/folder.vue'),
      name: 'AssetFolderManagement',
      meta: {
        title: 'router.asset'
      }
    }
  ]
}

export default attachmentRouter
